<template>
  <main class="page voucher-page">
    <section class="voucher">
      <header>
        <img src="../assets/images/consumption_voucher.png" alt="凭证" />
        <h1>电子消费凭证：</h1>
      </header>
      <div class="voucher-body">
        <div class="details">
          <p v-for="item in details" :key="item.label">
            <span>{{ item.label }}：</span><strong>{{ item.value }}</strong>
          </p>
        </div>
        <p class="statement">
          <b>*</b>
          客户声明：本人确认上述电子消费凭证全部内容及消费项目，是本人在商户进行消费的有效凭证，本人承诺按期归还消费分期款。
        </p>
      </div>
    </section>
    <div class="buttons">
      <van-button class="back-button" size="large" @click="$router.back()">返回</van-button
      ><van-button class="agree-button" type="primary" size="large" @click="next"
        >我已阅读，并同意</van-button
      >
    </div>
  </main>
</template>

<script>
export default {
  name: "ConsumptionVoucher",
  computed: {
    details() {
      return [
        ["客户姓名", "林若安"],
        ["身份证号码", "990101********0019"],
        ["联系方式", "199****1234"],
        ["申请编号", "TH202607170827"],
        ["申请日期", "2026-07-17"],
        ["首付金额", "3,600.00 元"],
        ["分期金额", "18,600.00 元"],
        ["消费总金额", "22,200.00 元"],
        ["机构名称", "星澜美学体验中心（虚构）"],
        ["消费项目", "光子嫩肤、皮肤清洁"],
      ].map(([label, value]) => ({ label, value }));
    },
  },
  methods: {
    next() {
      this.$router.push("/infomation");
    },
  },
};
</script>

<style lang="scss" scoped>
.voucher-page {
  padding: 28px 15px;
}
.voucher {
  overflow: hidden;
  border-radius: 0 0 16px 16px;
  background: #fff;
  box-shadow: 0 8px 18px rgba(208, 190, 195, 0.45);
}
header {
  display: flex;
  align-items: center;
  padding: 28px 26px;
  color: #fff;
  background: #d3936a url("../assets/images/consumption_voucher_bg.png")
    center/cover no-repeat;
}
header img {
  width: 24px;
  margin-right: 10px;
}
header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: normal;
}
.voucher-body {
  padding: 0 10px 16px;
}
.details {
  overflow: hidden;
  border: 1px solid #e7dfe8;
  border-radius: 14px;
}
.details p {
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 13px 12px;
  border-bottom: 1px solid #eee8ef;
  font-size: 16px;
}
.details p:last-child {
  border: 0;
}
.details strong {
  color: #d3936a;
  font-weight: 400;
  text-align: right;
}
.statement {
  padding: 6px;
  font-size: 13px;
  line-height: 18px;
}
.statement b {
  color: #e44;
}
.buttons {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}
.buttons .van-button {
  border-radius: 6px;
  font-size: 16px;
}
.buttons .back-button {
  flex: 2;
  border-color: #d3936a;
  color: #d3936a;
}
.buttons .agree-button {
  background: linear-gradient(90deg, #E1A379 0%, #B36E47 100%) !important;
  flex: 3;
}
</style>
